import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@/routes";
import { AuthProvider } from "@/auth/AuthProvider";

// Application root: client-side routing over the static SPA, wrapped in the
// broker auth context. AuthProvider attempts a silent session restore on mount
// (the httpOnly refresh cookie), so a returning broker stays signed in across
// reloads without the SPA ever persisting a token itself (CLAUDE.md #5/#9).
//
// BrowserRouter uses the History API; under static hosting CloudFront serves
// index.html for unknown paths so deep links boot the app and the router takes
// over (the `*` route renders the in-app 404). The route table lives in
// src/routes.tsx so it can be exercised in isolation under a MemoryRouter.
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
